import { createContext } from 'react'

const SCContext = createContext(null)

export { SCContext }
